import { useEffect, useRef } from 'react';

import { useTopBannersHeight } from 'modules/layout/components/TopBannersHeightProvider';

export const useTopBannersRef = () => {
  const { setTopBannersHeight } = useTopBannersHeight();
  const resizeObserver = useRef<ResizeObserver | null>();

  const refCallback = (element: HTMLDivElement) => {
    if (element) {
      setTopBannersHeight(element.clientHeight);

      resizeObserver.current = new ResizeObserver(() => {
        setTopBannersHeight(element.clientHeight);
      });

      resizeObserver.current.observe(element);
    } else {
      resizeObserver.current?.disconnect();
      resizeObserver.current = null;
    }
  };

  useEffect(
    () => () => {
      resizeObserver.current?.disconnect();
      setTopBannersHeight(0);
    },
    // no dependencies are needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return refCallback;
};
